<template>
  <teleport to="#teleport-modal">
    <transition name="fade">
      <div
        v-show="showDialog"
        v-body-scroll-lock="showDialog === true"
        class="fixed top-0 left-0 w-full h-full flex items-center justify-center z-50"
        style="background: rgba(152, 163, 190, 0.3)"
      >
        <div class="bg-white p-8 rounded-lg" style="width: 724px">
          <div class="font-semibold text-base text-gray-92 leading-5 mb-4">
            メッセージ機能に関する同意事項
          </div>
          <div class="font-light text-gray-92 leading-6 pb-4 h-auto">
            <div>
              マイページのメッセージ機能（以下「本機能」といいます。）をご利用いただく場合、以下の事項（以下「本事項」といいます。）へご同意ください。同意する場合は、以下の内容をご確認の上「同意して閉じる」のボタンをクリックしてください。<br /><br />
              本機能は、当社、カスタマー及びPRONIパートナーの三者間において、メッセージその他の情報のやり取りを行うことができる機能です。<br /><br />
              当社は、お客様が本機能により送信するメッセージの内容、お客様の本機能の利用履歴等（お客様が本機能により過去に送信したメッセージの内容、お客様の本機能の過去の利用履歴等を含みます。）を閲覧し、本サービスの提供、本サービスの改善及び最適化、不正の防止並びに新サービスの開発等（以下「本目的」といいます。）のために利用する場合があります。<br /><br />
              なお、メッセージを送信する相手方が本事項に同意していない場合は、当社を除く、カスタマー及びPRONIパートナーの二者間における本機能の利用となります。この場合も、当社は、本事項に同意いただいたお客様の送信したメッセージの内容、送信先、送信日時及び送信回数等については閲覧し、本目的のために利用する場合があります。<br />
            </div>
          </div>
          <div class="text-center">
            <button
              class="bg-secondary-main font-semibold text-white leading-10 px-10 rounded focus:outline-none hover:button"
              @click="agreeAction(true)"
            >
              同意して閉じる
            </button>
          </div>
          <div
            class="text-center mt-4 text-gray-92 leading-5 text-sm cursor-pointer"
          >
            同意しない場合は、<span
              class="no-action"
              @click="agreeAction(false)"
              >こちらをクリック</span
            >
          </div>
          <div class="text-center mt-4 text-gray-62 leading-5 text-sx">
            同意しない場合でもマイページのすべての機能をご利用いただけます。<br />
            この設定は後から変更できます。
          </div>
        </div>
      </div>
    </transition>
  </teleport>
</template>
<script>
import { inject } from 'vue';
import axios from '@/utils/axiosAuth.js';
export default {
  props: {
    showDialog: Boolean,
    sellerId: Number,
  },
  emits: ['close-dialog'],
  setup(props, { emit }) {
    const globalMethods = inject('globalMethods');
    const agreeAction = async (agree) => {
      await axios
        .post(`/sellers/${props.sellerId}/msg-func-agreement/update`, {
          has_msg_func_agreed: agree,
        })
        .then(() => emit('close-dialog'))
        .catch((e) => {
          globalMethods.updateModal(
            true,
            'URLが正しくないか、通信エラーが発生しました。',
            e.systemMessage || '',
            e.callback
          );
          globalMethods.sendLog(e);
        });
    };
    return {
      agreeAction,
    };
  },
};
</script>

<style lang="scss" scoped>
.no-action {
  text-decoration: none;
  position: relative;
}
.no-action:after {
  content: '';

  width: 100%;
  position: absolute;
  left: 0;
  bottom: -1px;
  @apply border-b;
}
</style>
